module.exports = __webpack_public_path__ + "static/img/1.e483f94e.png";